import { render, staticRenderFns } from "./DrinkingWater.vue?vue&type=template&id=d15e7b74&scoped=true&"
import script from "./DrinkingWater.vue?vue&type=script&lang=js&"
export * from "./DrinkingWater.vue?vue&type=script&lang=js&"
import style0 from "./DrinkingWater.vue?vue&type=style&index=0&id=d15e7b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15e7b74",
  null
  
)

export default component.exports